import React, { useState, useEffect } from "react";
import Layout from "../components/Layout/Layout";
import axios from "axios";
import { useCart } from "../context/cart";
import toast from "react-hot-toast";
import ProductCard from "./ProductCard";

const Products = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [cart, setCart] = useCart();

  const PALETTE = {
    DARK_NAVY: "#1C2E4A",
    ACCENT_BROWN: "#7C4F2B",
  };

  const getAllProducts = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get("/api/v1/product/get-product");

      if (data?.success) {
        setProducts(data.products);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
      toast.error("Something went wrong while fetching products");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllProducts();
  }, []);

  return (
    <Layout>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 mt-16 sm:mt-20">
        <div className="text-center mb-12">
          <h1
            className="text-3xl sm:text-4xl font-light tracking-widest uppercase mb-3"
            style={{ color: PALETTE.DARK_NAVY }}
          >
            All Products
          </h1>
          <div
            className="w-24 h-px mx-auto mb-4"
            style={{ backgroundColor: PALETTE.ACCENT_BROWN }}
          />
          <p className="text-gray-500 text-sm sm:text-base">
            Explore our exclusive collection of premium products
          </p>
        </div>

        {loading ? (
          <div className="flex justify-center items-center py-24">
            <div className="animate-pulse flex flex-col items-center gap-3">
              <div className="w-10 h-10 border-4 border-gray-300 border-t-[#1C2E4A] rounded-full animate-spin"></div>
              <p className="text-gray-500 font-medium tracking-wide">
                Loading products...
              </p>
            </div>
          </div>
        ) : products.length === 0 ? (
          <div className="text-center py-20 bg-gray-50 rounded-xl border border-gray-200">
            <h2 className="text-xl font-medium text-gray-700 mb-2">
              No Products Found
            </h2>
            <p className="text-gray-500 text-sm">
              We are adding new products soon. Please check back later!
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-6 sm:gap-8 justify-items-center">
            {products.map((p) => (
              <ProductCard
                key={p._id}
                product={p}
                cart={cart}
                setCart={setCart}
              />
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
};

export default Products;
